/* Disable hover event on all el on body scrolling */
;
(function () {

    let body = document.body,
        timer;

    window.addEventListener('scroll', function() {
        clearTimeout(timer);
        if(!body.classList.contains('m-disable-hover')) {
            body.classList.add('m-disable-hover')
        }

        timer = setTimeout(function(){
            body.classList.remove('m-disable-hover')
        },500);
    }, false);

})();